import { render, staticRenderFns } from "./HLayout.vue?vue&type=template&id=b8984f92&scoped=true&"
import script from "./HLayout.vue?vue&type=script&lang=js&"
export * from "./HLayout.vue?vue&type=script&lang=js&"
import style0 from "./HLayout.vue?vue&type=style&index=0&id=b8984f92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8984f92",
  null
  
)

export default component.exports